var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.newOptions && _vm.newOptions.length>0)?_c('LayoutForm',{key:Math.random(),ref:"layoutForm",staticClass:"layout-box",class:{
      left:_vm.newPosition === 'left',
      center:_vm.newPosition === 'center',
      right:_vm.newPosition === 'right',
      justify:_vm.newPosition === 'justify',
    },attrs:{"form":_vm.newOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }